const apiConfig = {
  STORE_API:
    process.env.REACT_APP_STORE_API ||
    "https://falcon-direct.t2sonline.com/store",
  API_BILLING:
    process.env.REACT_APP_API_BILLING ||
    "https://falcon-direct.t2sonline.com/billing",
  CARD_SECRET_KEY: process.env.REACT_APP_CARD_SECRET_KEY || "btspo",
  APP_HOOK_AUTH_TOKEN: process.env.REACT_APP_HOOK_AUTH_TOKEN || "8c9b638123af8cbef6172214b17ac04f03483cd9aa1ca2ccb975111d720133ee",
  // Stripe configuration for local development
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_2WTrEv3i9W2g9Mhn83BcSsXx',
  //SIT_STRIPE_PUBLISHABLE_KEY: "pk_test_51Q13ZVEYspZAs6dHBXJyvS6pw9AmKTFEAmCei0zNMkrrgRaeuEIc1buNeXZagexIhSYJoN5fhGxqEggnL7sIlr7V00f1z6qvjx"
  SAVE_CARD_URL: process.env.SAVE_CARD_URL || "https://ms.foodhub.com/api/fm/billing"
};

export default apiConfig;